import React from 'react';
import AppRoutes from './routes/AppRoutes';
import './App.css';

/**
  * Componente principal da aplicação
  * Configura o sistema de rotas e providers globais
  */
import { useEffect } from 'react';

function App() {

  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
